import { connect } from 'react-redux'

import history from 'startup/common/history'
import { SIGN_UP_START_PATH } from 'ui/routes/start/paths'

import { isLoggedIn } from '@/common/redux/account/selectors'
import { showAlert } from '@/common/redux/alert/actionCreators'
import { getCookieBannerFeatureEnabled } from '@/common/redux/config/selectors'
import { trackingIdentify } from '@/common/redux/tracking/actionCreators'
import { isLoggedInWillsUser, getUser } from '@/common/redux/user/selectors'

import MainLayout from './component'

const mapStateToProps = (state) => {
  return {
    isLoggedInWillsUser: isLoggedInWillsUser(state),
    isLoggedIn: isLoggedIn(state),
    isModalOpen: !state.modal.hide && !!state.modal.component,
    rootUrl: state.config.ROOT_URL,
    isProduction: state.config.RELEASE_ENV === 'production',
    isCookieBannerFeatureEnabled: getCookieBannerFeatureEnabled(state),
    maintenancePeriodStartDate: state.config.MAINTENANCE_PERIOD_START_DATE,
    maintenancePeriodEndDate: state.config.MAINTENANCE_PERIOD_END_DATE,
  }
}

const mapDispatchToProps = {
  trackUser: () => (dispatch, getState) => {
    const state = getState()
    const user = getUser(state)

    dispatch(trackingIdentify(user))
  },

  showAlert:
    ({ successAlert, errorAlert }) =>
    (dispatch) => {
      history.replace('/')

      if (successAlert) {
        return dispatch(showAlert('success', successAlert))
      }

      if (errorAlert) {
        return dispatch(showAlert('error', errorAlert))
      }
    },

  redirectToOnboardingFlow: () => () => {
    history.replace(SIGN_UP_START_PATH)
  },
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout)
